import React from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui";
import { DataTable, DataTableProps } from "@/components/DataTable";

export interface TableTabsProps<TData> {
  activeTab?: number;
  tabs: {
    label?: string;
    value?: DataTableProps<TData>;
    children?: React.ReactNode;
  }[];
  className?: string;
  numSkeletonRows?: number;
}

export const TableTabs = <TData,>({
  activeTab,
  tabs,
  className = "rounded-lg border shadow-sm",
  numSkeletonRows = 5,
}: TableTabsProps<TData>) => {
  return (
    <Tabs defaultValue={String(activeTab)}>
      <TabsList>
        {tabs.map((tab, index) => (
          <TabsTrigger key={tab.label + "tab"} value={String(index)}>
            {tab.label || `Tab ${index + 1}`}
          </TabsTrigger>
        ))}
      </TabsList>
      {tabs.map((tab, index) => (
        <TabsContent
          key={tab.label + "tab"}
          value={String(index)}
          className={className}
        >
          {tab.children ? (
            tab.children
          ) : (
            <div className={className}>
              {tab.value && (
                <DataTable
                  {...tab.value}
                  numSkeletonRows={
                    tab.value?.numSkeletonRows ?? numSkeletonRows
                  }
                />
              )}
            </div>
          )}
        </TabsContent>
      ))}
    </Tabs>
  );
};
